import { ArrecadacaoDemonstrativoContasBancariasEnum } from "core/features/arrecadacoes/enums";
import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";

export interface SelectContasBancariasProcessarArrecadacaoProps<T = any>
  extends SelectBaseAntdProps<T> {
  value: any;
  onChange: (v: any) => void;
}

function SelectContasBancariasProcessarArrecadacao({
  value,
  onChange,
  ...rest
}: SelectContasBancariasProcessarArrecadacaoProps) {
  return (
    <SelectBaseAntd
      size="large"
      placeholder="Selecione"
      value={value}
      allowClear
      getPopupContainer={(node) => node.parentNode}
      showSearch
      onChange={onChange}
      optionFilterProp="label"
      options={[
        {
          label: "Todas as contas bancárias",
          value: ArrecadacaoDemonstrativoContasBancariasEnum.Todas,
        },
        {
          label: "Somente a conta bancária da cobrança",
          value: ArrecadacaoDemonstrativoContasBancariasEnum.SomenteCobranca,
        },
      ]}
      {...rest}
    />
  );
}

export default SelectContasBancariasProcessarArrecadacao;
